import { render, staticRenderFns } from "./myWallet.vue?vue&type=template&id=48b7b335&scoped=true&"
import script from "./myWallet.vue?vue&type=script&lang=js&"
export * from "./myWallet.vue?vue&type=script&lang=js&"
import style0 from "./myWallet.vue?vue&type=style&index=0&id=48b7b335&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b7b335",
  null
  
)

export default component.exports